var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont icon-fanhui icon-back",attrs:{"title":"返回"},on:{"click":_vm.back}})
}
var staticRenderFns = []

export { render, staticRenderFns }